import { render, staticRenderFns } from "./GSelectContactButton.vue?vue&type=template&id=08108434&scoped=true&"
import script from "./GSelectContactButton.vue?vue&type=script&lang=ts&"
export * from "./GSelectContactButton.vue?vue&type=script&lang=ts&"
import style0 from "./GSelectContactButton.vue?vue&type=style&index=0&id=08108434&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08108434",
  null
  
)

export default component.exports